import CouponInput from "../../components/CouponInput";

const DisconnectOrgModal = ({
  organizationName,
  provider = "xero",
  hasDefaultPaymentMethod = false,
  couponCode = "",
  onCouponCodeChange,
  appliedDiscount = null,
  onDiscountApplied,
}) => {
  const brand = provider === "qbo" ? "QuickBooks Online" : "Xero";

  return (
    <div className="py-6 text-gray-600 text-sm border-b border-gray-200">
      <div>
        Are you sure you want to downgrade this organization to Vault?
        {organizationName ? (
          <b className="ml-2 text-gray-900">{organizationName}</b>
        ) : null}
      </div>
      <div className="mt-4 leading-relaxed">
        This will disconnect your <strong>{brand}</strong> company from
        automatic backups and move your plan to <strong>Vault</strong> ($2.49/month). Your
        existing backups stay in the cloud while Vault is active.
      </div>
      {provider === "qbo" && (
        <div className="mt-3 text-xs text-gray-500">
          After you confirm, you may be redirected to complete payment if your
          account requires it.
        </div>
      )}

      {hasDefaultPaymentMethod && (
        <div className="mt-5 border-t border-gray-100 pt-4">
          <CouponInput
            value={couponCode}
            onChange={onCouponCodeChange}
            appliedDiscount={appliedDiscount}
            onDiscountApplied={onDiscountApplied}
          />
        </div>
      )}
    </div>
  );
};

export default DisconnectOrgModal;
